<template>
  <div class="container-fluid">
    <!-- <div class="row">
      <div class="col-12 mx-auto red-line py-2 px-0"></div>
    </div>-->

    <div
      class="col-12 col-md-8 col-lg-6 my-4 col-xl-4 px-0 px-md-3 mx-auto confirmScreenT"
    >
      <div class="text-center">
        <img
          src="@/assets/img/svg/cancelled.svg"
          width="120px"
          class="img-fluid"
        />
        <p class="tTitle mt-3">Sorry, Your Transaction has failed!</p>
        <router-link
          class="mt-3 btn btn-danger text-light"
          :to="{
            name: 'Home'
          }"
          >Home</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import { makeRequest } from "@/helper/internet.js";
import { TokenService, CountryService } from "@/services/storage.service";

export default {
  name: "confirmScreen",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {
    Slick,
    DatePick
  },

  data() {
    return {
      legacySystemHTML: "",
      bookingDetails: {},
      bookingId: "",
      paymentId: "",
      friendemail: "",
      errorMessage: "",
      CategoryID: "",
      CinemaScheduleID: "",
      movieId: "",
      ss_id: null,
      screen_id: null,
      md_id: null
    };
  },
  beforeMount() {},
  methods: {
    onClickHere() {
      let country = CountryService.getCountry();
      this.$router.push({
        name: "seatLayout",
        params: {
          categoryId: this.CategoryID,
          movieId: this.movieId,
          cinemaScheduleId: this.CinemaScheduleID,
          countryId: country.CountryID
        }
      });
    },
    print() {
      // Pass the element id here
      this.legacySystemHTML = `
        <div id="printMe" marginwidth="0" marginheight="0" style="display:none;font-family:Arial,sans-serif;background:#fff">
    <table bgcolor="#fff" cellpadding="0" cellspacing="0" width="100%" border="0" align="center" style="padding:10px 0 25px 0;margin:0 auto;background:#fff">
      <tbody><tr>
        <td width="100%" valign="top">
          <table cellpadding="0" cellspacing="0" width="600" border="0" align="center" bgcolor="ffffff" style="margin:0 auto;min-width:650px;max-width:650px; border: 1px solid #e5e5e5;">
            <tbody><tr>
              <td colspan="3" style="width:600px;background-color:#ffffff">
                <a href="" style="text-decoration:none;color:#010101" rel="noreferrer" target="_blank"  style="margin:0 auto;padding:0 10px 10px 10px;display:block;background-color:#ffffff;color:#010101" border="0" width="150">
                </a>
              </td>
            </tr>
            <tr>
              <td align="center" style="height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;">
              </td>
            </tr>
            <tr>
              <td align="center" style="padding:15px 25px 15px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;border:0;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);color:#828282">
                <img src="http://developmentgogocinema.binarynumbers.io/assets/img/logo-name.png">

              </td>
            </tr>
           <tr>
              <td align="center" style="padding:20px 25px 20px 25px;font-size:16px;font-weight:bold;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color:#2B2D42">
                  <span style="font-size: 30px; text-align: center; letter-spacing: -0.5px; color: #2B2D42;">Congratulations!</span>

              </td>
            </tr>

            <tr>
              <td align="center" style="padding:10px 25px 10px 25px;font-size: 14px;text-align: center;color: #2B2D42;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;">Your tickets for <span style="color: #45BB4D">${
                this.bookingDetails.Title
              }</span> are confirmed.
              </td>
            </tr>
            <tr>
              <td align="center" style="padding:5px 25px 5px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color: #2B2D42">Your Transaction ID : <span style="font-size: 18px;text-align: center;color: #2B2D42;">${parseInt(
                this.bookingId
              )}</span>
              </td>
            </tr>


            <tr>
              <td align="center" style="width:600px;padding:25px 10px 0 10px;text-align:left;background-color:#ffffff">
                <table align="center" cellpadding="0" cellspacing="0" style="width:580px;margin:0 auto;background-color:#ffffff">
                  <tbody><tr>
                    <td>
                      <table align="center" cellpadding="0" cellspacing="0" style="width:580px;margin:0 auto;background-color:#f5f5f5;border-radius:5px">
                        <tbody><tr>
                          <td>
                            <table align="center" cellpadding="0" cellspacing="0" style="width:580px;margin:0 auto;padding:10px;background-color:#f5f5f5;border-top-left-radius:5px;border-top-right-radius:5px">
                              <tbody><tr>
                                <td valign="top" align="center" style="width:580px;background-color:#f5f5f5">
                                  <table cellspacing="0" cellpadding="0" align="center" style="width:100%;background-color:#f5f5f5;margin:0px auto">
                                    <tbody>
                                        <tr>
                                      <td valign="top" align="center" style="width:60px;background-color:#f5f5f5;padding:10px 10px 0px 10px;">

                                        <img src="${
                                          this.bookingDetails.Image1
                                        }" width="auto" height="auto" style="max-width:100%;display:block;background-color:#f5f5f5;color:#010101;border-radius:5px;height:auto; border:0;">

                                      </td>

                                      <td valign="top" align="center" style="width:370px;background-color:#f5f5f5;padding:10px">
                                        <table cellspacing="0" cellpadding="0" align="center" style="width:100%;background-color:#f5f5f5;margin:0px auto">
                                          <tbody><tr>
                                            <td valign="top" align="left" style="padding:0px 5px 0px 0px;height:50px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;">
                                              <span style="font-size:20px;font-weight:bold;color:#252525;padding-bottom: 5px">${
                                                this.bookingDetails.Title
                                              }</span>
                                              <ul style="list-style: none; padding: 0px; margin:6px 0px 0px 0px; font-size: 14px;color: #252525">
                                                <li style="display: inline;">${
                                                  this.bookingDetails.Rated
                                                } |</li>
                                                <li style="display: inline;">${
                                                  this.bookingDetails.Language
                                                } |</li>
                                                <li style="display: inline;">${
                                                  this.bookingDetails.Format
                                                }</li>
                                              </ul>
                                              <hr style="background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%); height: 1px; border:0;">
                                            </td>
                                          </tr>


                                          <tr>
                                            <td valign="bottom" align="left" style="padding:10px 5px 10px 0px;font-size:16px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;color:#25AAD3">${
                                              this.bookingDetails.CinemaName
                                            }</td>
                                          </tr>
                                          <tr>
                                            <td valign="bottom" align="left" style="padding:10px 5px 10px 0px;font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-weight: bold;margin: 0px; font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;">${
                                              this.bookingDetails.ShowTime
                                            } | ${
        this.bookingDetails.ShowDate
      } </td>
                                            <td>

                                            </td>
                                          </tr>
                                           <tr>
                                            <td valign="bottom" align="left" style=" width: 50%; padding:10px 5px 10px 0px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;">
                                              <p style="font-size: 12px;line-height: 14px;color: #8D99AF;margin: 0;">Show Category: </p>
                                                 <p style="font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-weight: bold;margin: 0px;float: left;">${
                                                   this.bookingDetails
                                                     .CategoryName
                                                 } </p>

                                            </td>

                                               <td valign="bottom" align="left" style=" width: 50%; padding:10px 5px 10px 0px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;">

                                              <p style="font-size: 12px;line-height: 14px;color: #8D99AF;margin: 0;">Show Status</p>
                                                <p style="float: left;font-size: 18px;color: ${
                                                  this.bookingDetails
                                                    .ShowStatusMsg ==
                                                  "CONFIRMED"
                                                    ? "#45bb4d"
                                                    : this.bookingDetails
                                                        .ShowStatusMsg ==
                                                      "UNCONFIRMED"
                                                    ? "#dc3545"
                                                    : "#000"
                                                };font-weight: bold;font-family:Arial,sans-serif;  margin-top:5px;">
                                                  ${
                                                    this.bookingDetails
                                                      .ShowStatusMsg
                                                  }
                                                </p>

                                               </td>
                                          </tr>
                                        </tbody></table>
                                      </td>
                                    </tr>
                                  </tbody></table>
                                </td>
                              </tr>
                            </tbody></table>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top" style="width:580px;background-color:#f5f5f5;border:0">
                            <table cellspacing="0" cellpadding="0" align="center" style="width:580px;margin:0px auto;border:0">
                                      <tbody>
                                        <tr>
                                         <td valign="top" align="left" style="width:60px;height:40px;padding:10px 10px 0px 15px;vertical-align:top;font-family:Arial,sans-serif;text-align:center; color:#828282;font-weight:400;border:0">
                                            <p style="font-size: 18px; color: #252525;font-weight: bold;margin: 0px">${
                                              this.bookingDetails.SeatsCount
                                            }</p>
                                            <span style="font-size: 12px;line-height: 14px;color: #8D99AF; margin: 0px">Tickets</span>
                                          </td>
                                          <td valign="top" align="left" style="width:270px; padding:10px 10px 0px 15px;vertical-align:top;font-family:Arial,sans-serif;text-align:left; border:0">
                                            <p style="font-size: 12px;line-height: 14px;color: #8D99AF; margin: 0px">Seats selected:</p>
                                              <p style="font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-weight: bold;margin: 0px">${
                                                this.bookingDetails.Seats
                                              }</p>
                                          </td>
                                          <td valign="top" style="width:120px;border:0;height:107px;">

                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                          </td>
                        </tr>
                      </tbody></table>
                    </td>
                  </tr>
                </tbody></table>
              </td>
            </tr>
            <tr>
              <td valign="top" align="left" style="font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#828282">
                <table align="center" cellpadding="0" cellspacing="0" style="width:600px;font-family:Arial,sans-serif;margin:0 auto">
                  <tbody><tr>
                    <td align="left" style="width:580px;padding:15px 10px 15px 10px;font-size: 18px;text-align: right;color: #252525;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;font-weight:600;">Order Summary</td>
                  </tr>
                </tbody></table>
              </td>
            </tr>
            <tr>
              <td align="left" style="text-align:center;background-color:#ffffff">
                <table cellpadding="0" cellspacing="0" style="width:580px;padding:15px 25px 15px 25px;border:2px solid #f1f1f1;border-bottom:0px!important;border-top-left-radius:5px;border-top-right-radius:5px;font-family:Arial,sans-serif;margin:0 auto">
                  <tbody>
                  <tr>
                    <td valign="top" align="left" style="width:100%;font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#828282">
                      <table cellpadding="0" cellspacing="0" style="width:100%;padding:20px 0px;font-family:Arial,sans-serif;margin:0 auto">
                        <tbody><tr>
                          <td align="left"  style="width:50%;font-size:13px;font-family:Arial,sans-serif;text-align:left;vertical-align:bottom;background-color:#ffffff;color:#3c3c3c">
                            <p style="color:#828282;font-size:13px;margin:0;padding:0 0 4px 0;"></p>
                            <p style="font-size: 14px;line-height: 22px;color: #252525;margin:0;padding:0 0 4px 0">Tickets (${
                              this.bookingDetails.SeatsCount
                            }) :</p>
                            <!--<p style="font-size: 14px;line-height: 22px;color: #252525;margin:0;padding:0 0 4px 0">Promocode Discount :</p>
                            <p style="color:#828282;font-size:13px;margin:0;padding:0 0 4px 0">HappyGOGO</p>-->
                          </td>
                          <td align="right" style="width:50%;font-size:13px;font-family:Arial,sans-serif;text-align:right;vertical-align:bottom;background-color:#ffffff;color:#3c3c3c">
                            <p style="color:#828282;font-size:13px;margin:0;padding:0 0 4px 0"></p>
                            <p style="font-size: 18px;line-height: 28px;text-align: right;letter-spacing: -0.5px;color: #252525;margin:0;padding:0 0 4px 0">${
                              this.bookingDetails.Currency
                            } ${this.bookingDetails.Total}</p>
                            <!--<p style="font-size: 18px;line-height: 28px;text-align: right;letter-spacing: -0.5px;color: #E70D01;margin:0;padding:0 0 4px 0">- $2.00</p>-->
                          </td>
                        </tr>
                      </tbody></table>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top" align="left" style="width:100%;font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#828282">
                  </td></tr>
                  <tr>
                  </tr><tr>
                </tr></tbody></table>
              </td>
            </tr>
            <tr>
              <td align="center" style="width:580px;text-align:center;background-color:#ffffff">
                <table cellpadding="0" cellspacing="0" style="width:580px;margin:0 auto;background-color:#ffffff">
                  <tbody><tr>
                    <td valign="top" align="left" style="font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f1f1f1;color:#828282">
                      <table cellpadding="0" cellspacing="0" style="width:100%;padding:20px 25px 10px 25px;border-bottom:2px dashed #f1f1f1;font-family:Arial,sans-serif;margin:0 auto">
                        <tbody><tr>
                          <td align="left" style="font-size:16px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;font-weight:bold;background-color:#f1f1f1;color:#333333">AMOUNT PAID</td>
                          <td align="left" style="font-size:16px;font-family:Arial,sans-serif;text-align:right;vertical-align:top;font-weight:bold;background-color:#f1f1f1;color:#333333">${
                            this.bookingDetails.Currency
                          } ${this.bookingDetails.Total}</td>
                        </tr>
                      </tbody></table>
                    </td>
                  </tr>

                  <tr>
                    <td valign="top" align="center" style="width:580px;padding:20px 0;background-color:#ffffff">
                      <table cellspacing="0" cellpadding="0" align="center" style="width:100%;background-color:#ffffff;margin:0px auto">
                        <tbody><tr>
                          <td valign="top" align="left" style="width:260px;font-size:13px;font-weight:bold;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#3f474e">
                            <p style="font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;">Booking Date & Time:</p>
                            <p style="color:#252525;font-size:14px;margin:0;padding:0 0 4px 0">${
                              this.bookingDetails.BookingDate
                            }</td>
                          <td valign="top" align="left" style="width:240px;font-size:13px;font-weight:bold;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#3f474e">
                            <p style="font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;">Payment Method:</p>
                            <p style="color:#252525;font-size:14px;margin:0;padding:0 0 4px 0">${
                              this.bookingDetails.PaymentMethod
                            }</td>
                          <td valign="top" align="left" style="width:100px;font-size:13px;font-weight:bold;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#3f474e">
                            <p style="font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;">Ticket ID: </p>
                            <p style="color:#252525;font-size:14px;margin:0;padding:0 0 4px 0">${parseInt(
                              this.bookingId
                            )}</td>
                        </tr>
                      </tbody></table>
                    </td>
                  </tr>
                </tbody></table>
              </td>
            </tr>
            <tr>
              <td align="center" style="width:580px;text-align:center;background-color:#ffffff">
                <table cellpadding="0" cellspacing="0" style="width:580px;margin:0 auto;background-color:#ffffff">
                  <tbody>

                   <tr>
                      <td align="center" style="padding:15px 0 6px 0;font-size:11px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#fff;color:#787878">
                      <p style="padding:0 0 4px 0;margin:0; text-align: center"><img src="${
                        this.bookingDetails.QRCode
                      }" height="100px" width="100px"></p>
                      <p style="font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;text-align: center;">(Show this code at the gate)</p>
                    </td>
                </tbody></table>
              </td>
            </tr>
             <tr>
            <td align="center" style="height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;">

                <table cellspacing="0" cellpadding="0" align="center" style="width:25%;padding:5px 10px 5px 10px">
                        <tbody>
                        <tr>
                          <td style="vertical-align:top;text-align:center;border:0;">
                            <a href="#">
                             <img src="img/facebook-f-brands.svg" height="12px" width="12px">
                            </a>
                          </td>
                          <td style="vertical-align:top;text-align:center;border:0;">
                            <a href="#">
                              <img src="img/twitter-brands.svg" height="12px" width="12px">
                            </a>
                          </td>
                          <td style="vertical-align:top;text-align:center;border:0;">
                            <a href="#">
                             <img src="img/instagram-brands.svg" height="12px" width="12px">
                            </a>
                          </td>
                          <td style="vertical-align:top;text-align:center;border:0;">
                            <a href="#">
                              <img src="img/youtube-brands.svg" height="12px" width="12px">
                            </a>
                          </td>
                          <td style="vertical-align:top;text-align:center;border:0;">
                            <a href="#">
                              <img src="img/snapchat-ghost-brands.svg" height="12px" width="12px">
                            </a>
                          </td>
                        </tr>
                      </tbody></table>

              </td>
            </tr>
          </tbody></table>
        </td>
      </tr>
    </tbody>
  </table>
 </div>
      `;
      this.$nextTick(() => {
        this.$htmlToPaper("printMe");
      });
    },
    fetchBookingDetails: function() {
      let token =
        TokenService.getToken() ||
        "2bbad34b53aaeeb27d28f69068e32e3081d8defe4c738d3c50a53f822816a507";
      let payload = {
        BookingID: this.bookingId,
        PaymentID: this.paymentId
      };
      makeRequest("/Booking/GetBookingDetails", "POST", token, payload)
        .then(response => {
          const { error, res } = response;
          this.hideLoading();

          this.bookingDetails = res.data;
          this.bookingDetails.Seats = this.bookingDetails.Seats.split(",").join(
            ", "
          );
          this.bookingDetails.SeatsLeft =
            parseInt(this.bookingDetails.TotalSeat) -
            parseInt(this.bookingDetails.SeatsBooked);
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    validateBeforeSubmit(scope) {
      if (scope == "inviteFriend") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.showLoading();
            let token = TokenService.getToken();
            let payload = {
              FriendEmail: this.friendemail,
              BookingID: this.bookingId
            };
            makeRequest("/Booking/ResendTickets", "POST", token, payload)
              .then(response => {
                const { error, res } = response;
                this.hideLoading();

                if (!error && res.data.Status) {
                  this.errorMessage =
                    "Ticekt has been sent to your friend's email address";
                } else {
                  this.errorMessage = res.data.Message;
                }
                setTimeout(() => {
                  this.$refs.invitemodal.hide();
                }, 3000);
              })
              .catch(error => {
                this.errorMessage = "Something went wrong!";
                console.log("Error", error);
              });
            return;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
body {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background: url("../../assets/img/svg/bg.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/pages/failedPayment.vue